module.exports = __webpack_public_path__ + "img/gold.b1e92d91.png";